<template>
  <div id="shortMessage">
    <!-- <div style="height:40px;display:flex;justify-content: space-between;align-items:center;background:white;padding:0 24px;">
      <span><i class="iconfont icon-icon_back"></i></span>
      <span>短信历史:</span>
      <span><i class="iconfont icon-icon_refresh"></i></span>
    </div> -->
    <van-nav-bar title="短信历史" left-text="" left-arrow @click-left="clickbackfun" @click-right="clickrefreshfun">
      <template #left>
        <van-icon name="" class-prefix="iconfont icon-icon_back" size="16" />
      </template>
      <template #right>
        <van-icon name="" class-prefix="iconfont icon-icon_refresh" size="16" />
      </template>
    </van-nav-bar>
    <div class="contentMessage" ref="sendStatusRef">
      <div v-for="(item,index) of sendList" :key="index">
        <van-row :gutter="10" style="" v-if="item.msgType=='接收'">
          <van-col :span="3" style="display:flex;justify-content:flex-end">
            <van-image width="36" height="36" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newplatform/image/icon_received%20sucessfully.png"></van-image>
          </van-col>
          <van-col :span="21">
            <div>
              <span class="contentTime">{{item.createTime}}</span>
            </div>
            <span class="contentValue valueLeft" v-text="item.content"></span>
          </van-col>
        </van-row>
        <van-row style="display:flex;flex-direction: flex-end;" :gutter="10" v-else>
          <van-col :span="21" style="display:flex;flex-direction: column;align-items: flex-end;">
            <div>
              <span class="contentTime">{{item.createTime}}</span>
            </div>
            <span class="contentValue valueRight" v-text="item.content"></span>
          </van-col>
          <van-col :span="3">
            <van-image width="36" height="36" :src="item.sendStatus=='未接收'?'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newplatform/image/icon_sending.png':'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/newplatform/image/icon_sent%20sucessfully.png'"></van-image>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="submitSty">
      <div class="codindSty">
        <van-icon class-prefix="iconfont icon-icon_open" size="16" color="#666666" @click="show=true" />
        <span>{{ contentCodingText }}</span>
        <van-action-sheet v-model="show" :actions="codingList" @select="onSelect" close-on-click-action />
      </div>
      <van-row class="subBtn" type="flex">
        <van-col span="20">
          <van-field v-model="form.content" />
        </van-col>
        <van-col span="4" style="display:flex;justify-content: flex-end;">
          <van-button size="small" type="default" @click="submitfun">发送</van-button>
        </van-col>
      </van-row>

    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data () {
    return {
      form: {
        content: '',
        contentCode: '',
        msisdn: this.$route.query.msisdn,
        operator: this.$route.query.operator
      },
      sendList: [],
      show: false,
      contentCodingText: "编码方式",
      mobileCodingList: [
        { name: "ASCII", value: "1", },
        { name: "UCS2（支持中文）", value: "2", }
      ],
      unicomCodingList: [
        { name: "GB18030编码", value: "15", },
        { name: "ASCII", value: "0", },
        { name: "短消息写卡操作", value: "3", },
        { name: "二进制短消息utf-8（支持中文）", value: "4", },
        { name: "UCS2编码", value: "8", },
        { name: "(U)SIM相相关消息（支持中文）", value: "246", }
      ],
    };
  },
  computed: {
    codingList () {
      let arr=[]
      if(this.form.operator == '1'||this.form.operator == '2' ){
        arr= this.mobileCodingList
      }else if(this.form.operator == '3' ){
        arr= this.unicomCodingList
      }
      return arr
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList (message) {
      this.globel.requestUrl("/selfRacharge/findMsgList", { msisdn: this.form.msisdn }).then(res => {
        this.sendList = res.list
        if (message) Toast({ type: "success", message: "刷新成功", duration: 500 });
        this.$nextTick(() => {
          this.$refs.sendStatusRef.scrollTop = this.$refs.sendStatusRef.scrollHeight;
        })
      })
    },
    submitfun () {
      if (this.form.content == '')      {
        this.globel.showError("请先输入内容", 1000)
        return
      } else if (this.form.contentCode == '')      {
        this.globel.showError("请先选择编码方式", 1000)
        return
      }
      this.globel.showLoading()
      this.globel.requestUrl("/selfRacharge/sendMessage", this.form).then(res => {
        if (res.success)        {
          this.globel.showSucces("刷新成功", 1000)
          this.getList()
        }
      })
    },
    clickbackfun () {
      this.$router.push({ path: '/pay', query: { accessNum: this.form.msisdn } }).catch((err) => { console.log(err); })
    },
    clickrefreshfun () {
      this.globel.showLoading();
      this.getList(true)
    },
    onSelect (event) {
      this.form.contentCode = event.value;
      this.contentCodingText = event.name
    },
  },
  components: {

  },
};
</script>

<style scoped>
#shortMessage {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.contentMessage {
  flex: 1;
  background: #f1f3f6;
  color: #333333;
  overflow-y: auto;
}
.contentMessage .contentTime {
  color: #999999;
  line-height: 1.5rem;
}
.contentMessage .contentValue {
  display: inline-block;
  width: 21rem;
  padding: 1.5rem;
  margin: 0.4rem 0 1.6rem;
  line-height: 1.4rem;
  max-width: 100%;
  -webkit-word-wrap: break-word;
  -moz-word-wrap: break-word;
  -ms-word-wrap: break-word;
  -o-word-wrap: break-word;
  word-wrap: break-word;
}
.contentMessage .valueLeft {
  background: white;
  border-radius: 0 1.2rem 1.2rem 1.2rem;
}
.contentMessage .valueRight {
  border-radius: 1.2rem 0 1.2rem 1.2rem;
  background: #d8ecff;
}

.submitSty {
  height: 8.8rem;
  background: white;
  padding: 1.5rem;
  box-sizing: border-box;
}
.submitSty .codindSty {
  display: flex;
  align-items: center;
  line-height: 1.8rem;
}
.submitSty .codindSty > span {
  color: #666666;
  margin-left: 0.4rem;
}
.submitSty .subBtn {
  display: flex;
  justify-content: space-between;
  margin-top: 0.8rem;
}
.submitSty .subBtn .van-field {
  height: 3.3rem;
  background: #f1f3f6;
  border-radius: 0.4rem;
}
.submitSty .subBtn .van-button {
  padding: 0.6rem 1.2rem;
  background: #1689f9;
  border-radius: 0.4rem;
  border: none;
  color: #fff;
}
</style>
